var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:_vm.the_id},[_c('div',{staticStyle:{"overflow":"auto"},attrs:{"id":'sticky_main_scroll_' + _vm.the_id}},[_vm._t("default")],2),_vm._v(" "),_c('div',{attrs:{"id":'sticky_scroll_' + _vm.the_id}},[_c('div',{attrs:{"id":'fake_content_' + _vm.the_id}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }